import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState("loading");
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    if (!sid) return setStatus("error");
    let cancelled = false;
    let timer = null;
    let attempts = 0;
    const poll = async () => {
      if (cancelled) return;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (cancelled) return;
        setMeta(data);
        if (data.payment_status === "paid") return setStatus("paid");
        if (data.status === "expired" || data.payment_status === "failed") return setStatus("failed");
      } catch {}
      attempts++;
      if (attempts > 12) return setStatus("timeout");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; if (timer) clearTimeout(timer); };
  }, [sid]);

  return (
    <section className="mx-auto max-w-2xl px-4 py-24 text-center">
      {status === "loading" && (<>
        <Loader2 size={48} className="mx-auto animate-spin text-[#FFFFFF]"/>
        <h1 className="mt-6 font-display text-4xl uppercase">Verifica pagamento...</h1>
      </>)}
      {status === "paid" && (<>
        <CheckCircle2 size={64} className="mx-auto text-[#FFFFFF]"/>
        <h1 className="mt-6 font-display text-5xl uppercase" data-testid="payment-success">Pagamento ricevuto</h1>
        <p className="mt-3 text-white">Grazie! La tua transazione è confermata.</p>
        <div className="mt-2 font-mono text-xs text-white/50 break-all">ID: {sid}</div>
        <Link to="/" className="brutal-btn brutal-btn-outline mt-8 inline-flex">Torna alla home</Link>
      </>)}
      {(status === "failed" || status === "error" || status === "timeout") && (
        <div>
          <h1 className="font-display text-4xl uppercase text-white">Pagamento non completato</h1>
          <p className="mt-3 text-white/70">Riprova o contatta il circolo.</p>
          <Link to="/" className="brutal-btn brutal-btn-outline mt-8 inline-flex">Torna alla home</Link>
        </div>
      )}
    </section>
  );
}
